import { render, staticRenderFns } from "./FormP1.vue?vue&type=template&id=22345a31&scoped=true"
import script from "./FormP1.vue?vue&type=script&lang=ts"
export * from "./FormP1.vue?vue&type=script&lang=ts"
import style0 from "./FormP1.vue?vue&type=style&index=0&id=22345a31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22345a31",
  null
  
)

export default component.exports